export class PortModel {
  constructor(
    public id?: any,
    public portCode?: string,
    public fullName?: string,
    public country?: string,
    public timezone?: string,
    public berthingType?: string,
    public terminal?: string
  ) { }

  public fromJSON(json: any): PortModel {
    if (json) {
      this.id = json.id;
      this.portCode = json.portCode;
      this.fullName = json.fullName;
      this.country = json.country;
      this.timezone = json.timezone;
      this.berthingType = json.berthingType;
      this.terminal = json.terminal;
    }
    return this;
  }

  public fromJSONList(json: any): PortModel[] {
    if (json) {
      return json.map((element: any) => new PortModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      portCode: this.portCode,
      fullName: this.fullName,
      country: this.country,
      timezone: this.timezone,
      berthingType: this.berthingType,
      terminal: this.terminal,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.portCode ?? '';
  }
}
